import { ErrorMessage } from "@hookform/error-message";
import { useFormContext } from "react-hook-form";
import type { FC, PropsWithChildren } from "react";
import styles from "./styles.module.scss";

type Props = {
  name: string;
};

export const FormFieldWrapper: FC<PropsWithChildren<Props>> = ({ children, name }) => {
  const {
    formState: { errors },
  } = useFormContext();
  return (
    <div className={styles.root}>
      {children}
      <ErrorMessage
        errors={errors}
        name={name}
        render={({ message }) => <p className={styles.error}>{message}</p>}
      />
    </div>
  );
};
